<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索" @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '添加招聘会')" class="search-btn">添加招聘会</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>

          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">

              <FormItem
                label="招聘会主题"
                prop="Jname"
              >
                <Input
                  v-model="formValidate.Jname"
                  :maxlength="45"
                  placeholder="请输入招聘会主题"
                ></Input>

              </FormItem>
              <FormItem label="开始时间" prop="Jstime">
                <DatePicker  type="datetime" editable v-model="formValidate.Jstime" format="yyyy-MM-dd HH:mm:ss" placement="bottom-end" placeholder="请选择开始时间" ></DatePicker>
              </FormItem>

              <FormItem label="结束时间" prop="Jotime">
                <DatePicker  type="datetime" editable v-model="formValidate.Jotime" format="yyyy-MM-dd HH:mm:ss" placement="bottom-end" placeholder="请选择开始时间" ></DatePicker>
              </FormItem>
              <FormItem label="招聘会类型" prop="Jtype">
                <Select  v-model="formValidate.Jtype" placeholder="请选择招聘会类型" filterable>
                  <Option v-for="item in JtypeList" :value="item.value" :key="item.id">{{item.meaning}}</Option>
                </Select>
              </FormItem>
<!--              <FormItem label="实体摊位数量" prop="Jnum">-->
<!--                <Input-->
<!--                  v-model="formValidate.Jnum"-->
<!--                  :maxlength="10"-->
<!--                  placeholder="请输入实体摊位数量"-->
<!--                ></Input></FormItem>-->
              <FormItem label="招聘市场" prop="Mid">
                <Select  v-model="formValidate.Mid" placeholder="请选择市场" filterable>
                  <Option v-for="item in MarketList" :value="item.Mid" :key="item.Id">{{item.Mname}}</Option>
                </Select>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>

            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>

  </div>
</template>

<script>

  import {
    getJobfairlist,
    operationJobfair,
    getMarketlist,
    changeJobfair,
    uptojobfair
  } from '@/api/scinfo/scinfo.js'

  import { getsysparameterList } from '@/api/system/sys_parameter'

  // import {Notification} from 'element-ui';

  let moment = require('moment')
  export default {

    data () {
      return {
        spinShow: false,
        fullscreenLoading: false,
        JtypeList: [],
        MarketList: [],
        formValidate: {
          Id: 0,
          Mid: 0,
          Jname: '',
          Jstime: '',
          Jtype: 0,
          Jotime: '',
          Jstate: 0,
          Jnum: 0
        },
        searchVal: '',
        tableData: [],
        modalMap: {
          modalVisible: false,
          modalTitle: '新建'
        },
        tableSelectIdList: [],
        editModalData: '',
        pageNum: 1, // 当前页码
        pageTotal: 0, // 数据总数
        pageSize: 15, // 每页条数

        ruleValidate: {
          // admin_user: [{ required: true, message: "请选择管理用户", trigger: "change"}],
          Jname: [
            {
              required: true,
              message: '招聘会主题不能为空',
              trigger: 'blur'
            }
          ],

          Jstime: [
            {
              required: true,
              type: 'date',
              message: '开始时间不能为空',
              trigger: 'blur'
            }
          ],
          Jotime: [
            {
              required: true,
              type: 'date',
              message: '结束时间不能为空',
              trigger: 'blur'
            }
          ],
          Jtype: [
            {
              required: true,
              message: '请选择类型',
              trigger: 'change'
            }
          ],
          Mid: [
            {
              required: true,
              message: '请选择市场',
              trigger: 'change'
            }
          ]

        },
        columns: [
          {
            type: 'selection',
            key: 'Id',
            width: 60,
            fixed: 'left',
            align: 'center'
          },
          {
            title: '招聘会主题',
            key: 'Jname',
            align: 'center',
            width: 200,
            fixed: 'left',
            sortable: true
          },
          {
            title: '开始时间',
            key: 'Jstime',
            align: 'center',
            width: 200,
            fixed: 'left',
            sortable: true
          },
          {
            title: '结束时间',
            key: 'Jotime',
            align: 'center',
            width: 200,
            sortable: true
          },

          {
            title: '摊位情况',
            key: 'com_count',
            align: 'center',
            width: 150,
            sortable: true
          },
          {
            title: '类型',
            key: 'Jtype_CN',
            align: 'center',
            width: 150,
            sortable: true
          },
          {
            title: '招聘市场',
            key: 'M_Mname',
            align: 'center',
            width: 200,
            sortable: true
          },
          {
            title: '状态',
            key: 'Jstate_CN',
            align: 'center',
            width: 100,
            fixed: 'right',
            sortable: true
          },
          {
            title: '数据',
            key: 'handle',
            width: 100,
            align: 'center',
            fixed: 'right',
            render: (h, params) => {
              if (params.row.Jstate == 1) {
                return h('div', [
                  h(
                    'Upload', {
                      props: {
                        data: { Jid: params.row.Id },
                        action: '/api/v1/scinfo/uploadfile/',
                        'on-success': this.handleSuccess, // 上传前调用函数
                        'before-upload': this.handleBeforeUpload, // 上传前调用函数
                        accept: '.xls, .xlsx'
                      }
                    },
                    [h(
                      'Button',
                      {
                        props: {
                          type: 'warning',
                          size: 'small'
                        }

                      },
                      '导入'
                    )]

                  )

                ])
              }
            }
          },
          {
            title: '操作',
            key: 'handle',
            width: 200,
            align: 'center',
            fixed: 'right',
            render: (h, params) => {
              if (params.row.Jstate == 1) {
                return h('div', [
                                   h(
                    'Button',
                    {
                      props: {
                        type: 'primary',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.editModal(params.row, 'put', '修改')
                        }
                      }
                    },
                    '编辑'
                  ),
                h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.changstate(params.row)
                        }
                      }
                    },
                    '暂停'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small'
                      },
                      on: {
                        click: () => {
                          this.delData(params)
                        }
                      }
                    },
                    '删除'
                  )
                ])
              } else if (params.row.Jstate == 2) {
                return h('div', [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'primary',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.editModal(params.row, 'put', '修改')
                        }
                      }
                    },
                    '编辑'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'success',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.changstate(params.row)
                        }
                      }
                    },
                    '启用'
                  ),

                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small'
                      },
                      on: {
                        click: () => {
                          this.delData(params)
                        }
                      }
                    },
                    '删除'
                  )
                ])
              } else {
                return h('div', [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'primary',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.editModal(params.row, 'put', '修改')
                        }
                      }
                    },
                    '编辑'
                  ),

                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small'
                      },
                      on: {
                        click: () => {
                          this.delData(params)
                        }
                      }
                    },
                    '删除'
                  )
                ])
              }
            }
          }
        ]
      }
    },
    methods: {

      getJobfairlist (key, value) {
        this.spinShow = true
        value = '6|1'
        getJobfairlist(this.pageNum, this.pageSize, key, value).then(res => {
          if (res.data.code === 0) {
            this.pageTotal = res.data.count
            this.tableData = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
          this.spinShow = false
        })
      },
      handleSuccess (res, file) {
        this.$confirm('上传成功，是否导入?', '选择', {
          distinguishCancelAndClose: true,
          confirmButtonText: '导入',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.uptojobfair(file)
          // return true
        }).catch(action => {
          // return false
        })
      },
      handleBeforeUpload (file) {
        const fileExt = file.name.split('.').pop().toLocaleLowerCase()
        if (fileExt === 'xlsx' || fileExt === 'xls') {
          return true
        } else {
          this.$Notice.warning({
            title: '文件类型错误',
            desc: '文件：' + file.name + '不是EXCEL文件，请选择后缀为.xlsx或者.xls的EXCEL文件。'
          })
          return false
        }
      },
      handleRemove (index) {
        this.formValidate.args_items[index].status = 0
      },

      // table 选中的ID
      handleSelectChange (val) {
        let SelectIdList = []
        val.forEach(item => {
          SelectIdList.push(item.Id)
        })

        this.tableSelectIdList = SelectIdList
      },

      closeModal () {
        this.dialog.show = false
      },
      getJtypeList () {
        getsysparameterList('jobfair_info', 'Jtype').then(res => {
          if (res.data.code === 0) {
            this.JtypeList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },
      getMarketList () {
        getMarketlist().then(res => {
          if (res.data.code === 0) {
            this.MarketList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },
      uptojobfair (paramsRow) {
        setTimeout(() => {
          uptojobfair(paramsRow).then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)

              if (this.searchVal) {
                this.getJobfairlist(this.searchVal)
              } else {
                this.getJobfairlist()
              }
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }, 1000)
      },
      changstate (paramsRow) {
        setTimeout(() => {
          changeJobfair(paramsRow, 'PUT').then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)

              if (this.searchVal) {
                this.getJobfairlist(this.searchVal)
              } else {
                this.getJobfairlist()
              }
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }, 1000)
      },
      editModal (paramsRow, meth, mtitle) {
        this.modalMap.modalVisible = true
        this.modalMap.modalTitle = mtitle
        this.editModalData = meth
        this.getJtypeList()
        this.getMarketList()
        var day2 = new Date()
        day2.setTime(day2.getTime())
        var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
        if (paramsRow && paramsRow.Id) {
          this.formValidate = {
            Id: paramsRow.Id,
            Mid: paramsRow.Mid.toString(),
            Jname: paramsRow.Jname,
            Jstime: paramsRow.Jstime,
            Jtype: paramsRow.Jtype.toString(),
            Jotime: paramsRow.Jotime,
            Jstate: paramsRow.Jstate,
            Jnum: paramsRow.Jnum,
            Jauth: paramsRow.Jauth
          }
        } else {
          this.formValidate = {
            Id: 0,
            Mid: 0,
            Jname: '',
            Jstime: s2,
            Jtype: 1,
            Jotime: s2,
            Jstate: 1,
            Jnum: 0,
            Jauth: '000001'
          }
        }
      },
      handleSubmit (value) {
        this.$refs[value].validate((valid) => {
          if (valid) {
            setTimeout(() => {
              this.formValidate.Jstime = moment(this.formValidate.Jstime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
              this.formValidate.Jotime = moment(this.formValidate.Jotime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
              operationJobfair(this.formValidate, this.editModalData).then(res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)

                  if (this.searchVal) {
                    this.getJobfairlist(this.searchVal)
                  } else {
                    this.getJobfairlist()
                  }

                  this.modalMap.modalVisible = false
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
            }, 1000)
            // this.$Message.success('Success!');
          } else {
            this.$Message.error('缺少必要参数')
          }
        })
      },

      handleReset (name) {
        this.$refs[name].resetFields()
      },

      handlerDelete () {
        // console.log(this.tableSelectIdList.length)
        if (this.tableSelectIdList.length > 0) {
          if (confirm(`确定要批量删除选中设备 `)) {
            operationJobfair({ 'id_list': this.tableSelectIdList }, 'delete').then(
              res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)
                  this.getJobfairlist(this.searchVal)
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
          }
        } else {
          this.$Message.info(`你总要选中点什么吧`)
        }
      },
      // 删除
      delData (params) {
        if (confirm(`确定要删除 ${params.row.Jname}`)) {
          // console.log(params.row.id)
          operationJobfair(
            {
              'id': params.row.Id
            },
            'delete'
          ).then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)
              this.tableData.splice(params.index, 1)
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }
      },

      handleSearch () {
        this.getJobfairlist(this.searchVal)
      },
      // 点击节点
      // 翻页
      changePage (value) {
        this.pageNum = value
        if (this.searchVal) {
          this.getJobfairlist(this.searchVal)
        } else {
          this.getJobfairlist()
        }
      },
      // 切换分页
      handlePageSize (value) {
        this.pageSize = value
        this.pageNum = 1
        if (this.searchVal) {
          this.getJobfairlist(this.searchVal)
        } else {
          this.getJobfairlist()
        }
      },
      searchinput () {
        if (this.searchVal) {
          this.getJobfairlist(this.searchVal)
        } else {
          this.getJobfairlist()
        }
      }
    },

    watch: {
      searchVal (val) {
        this.searchVal = val
        // this.getServerList(this.searchVal)
      }
    },
    mounted () {
      this.getJobfairlist()
    }
  }

</script>

<style lang="less" scoped>
  .search-con {
    padding: 10px 0;

    .search {
      &-col {
        display: inline-block;
        width: 200px;
      }

      &-input {
        display: inline-block;
        width: 200px;
        margin-left: 2px;
      }

      &-btn {
        margin-left: 2px;
      }
    }
  }
</style>
